import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Container, Grid, GridColumn, Icon, Button} from "semantic-ui-react";
import MobileApplyNow from "./common/MobileApplyNow";
import EligibilityRequirements from "./common/EligibilityRequirements";
import ApplyNow from "./common/ApplyNow";

class HowToApply extends PureComponent {
  static propTypes = {
    show: PropTypes.object,
    page: PropTypes.object,
    season: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  toggleVisibility = () => this.setState({ visible: !this.state.visible });

  closeMenu = () => this.setState({ visible: false });

  createSteps(page, hexColor) {
    const steps = [];

    if (page.step1C) {
      steps.push(
        <div className="step" key="1">
          <h3 style={{ color: `#${hexColor}` }}>Step 1</h3>
          <div className="content">
            <div className="description">{page.step1C}</div>
          </div>
        </div>
      );
    }

    if (page.step2C) {
      steps.push(
        <div className="step" key="2">
          <h3 style={{ color: `#${hexColor}` }}>Step 2</h3>
          <div className="content">
            <div className="description">{page.step2C}</div>
          </div>
        </div>
      );
    }

    if (page.step3C) {
      steps.push(
        <div className="step" key="3">
          <h3 style={{ color: `#${hexColor}` }}>Step 3</h3>
          <div className="content">
            <div className="description">{page.step3C}</div>
          </div>
        </div>
      );
    }

    if (page.step4C) {
      steps.push(
        <div className="step" key="4">
          <h3 style={{ color: `#${hexColor}` }}>Step 4</h3>
          <div className="content">
            <div className="description">{page.step4C}</div>
          </div>
        </div>
      );
    }

    return steps;
  }

  renderTips(tips) {
    return (
      <GridColumn className="ui sixteen wide mobile five wide computer right floated tablet-up">
        <div className="ui fluid card noShadow tip">
          <div
            className="content invertedPrimary"
            style={{ backgroundColor: `#${this.props.season.hexColorCodeC}` }}
          >
            <div className="header">
              <h4>Tip</h4>
            </div>
          </div>
          <div
            className="content shaded padded"
            dangerouslySetInnerHTML={{ __html: tips }}
          />
        </div>
      </GridColumn>
    );
  }

  fixPageContent(pageContent) {
    pageContent = pageContent.split("target=\"_blank\"");

    for (let content in pageContent) {
      if (pageContent.length !== parseInt(content) + 1 && !pageContent[content].includes("mailto:")) {
        pageContent[content] += "target=\"_blank\"";
      }
    }

    return pageContent.join();
  }
  
  render() {
    const { show, page, season } = this.props;
    const tips = page && page.tipsC ? this.renderTips(page.tipsC) : '';
    let pageContent = '';
    if (page && page.pageContentC) {
      pageContent = this.fixPageContent(page.pageContentC);
    }
    
    if (page) {
      return (
        <div>
          <Container id="mainContent" className="ui">
            <Grid className="ui">
              <GridColumn className="pageShowTitle">
                <h3
                  className="ui dividing header"
                  style={{ color: `#${season.hexColorCodeC}` }}
                >
                  {show.name} Casting
                </h3>
                <Button
                  onClick={this.toggleVisibility}
                  id="applyToggle"
                  className="tiny ui primary tablet-down mobileToggle"
                >
                  <Icon className="sidebar" />
                  Apply Now
                </Button>
              </GridColumn>
            </Grid>

            <MobileApplyNow
              season={season}
              visible={this.state.visible} toggleVisibility={this.toggleVisibility} />

            <Grid className="ui stackable" onClick={this.closeMenu}>
              <GridColumn className="ui sixteen wide mobile eight wide computer">
                <h1>{page.pageTitleC}</h1>

                <p className="lead">{page.leadParagraphC}</p>

                <style>{"\
                .inner-html a {\
                  color:#" + season.hexColorCodeC + " !important;\
                }\
              "}</style>

                <div className="inner-html" dangerouslySetInnerHTML={{ __html: pageContent}} />

                <div className="ui vertical steps borderless">
                  {this.createSteps(page, season.hexColorCodeC)}
                </div>

                <div className="ui hidden padded divider" />

                <EligibilityRequirements hexColorCodeC={season.hexColorCodeC} />
              </GridColumn>

              <ApplyNow
                season={season}
              />

              {tips}
            </Grid>
          </Container>
        </div>
      );
    }
    return <div />;
  }
}

const mapStatesToProps = (state, ownProps) => ownProps;

export default connect(mapStatesToProps)(HowToApply);



// WEBPACK FOOTER //
// ./src/components/HowToApply.js